import React, { useEffect, useState } from "react";
import { Textfield } from "../../../../components/core";
import { NumberFormatBase } from "react-number-format";

export default function StorageTimeLimitTable({
	className,
	data = {},
	handleChange,
	disabled = false,
	isSuccess,
}) {
	const [fieldEdited, setFieldEdited] = useState({
		storageTakebackLimit: false,
		storagePulloutLimit: false,
	});

	useEffect(() => {
		if (isSuccess) {
			setFieldEdited({
				storageTakebackLimit: false,
				storagePulloutLimit: false,
			});
		}
	}, [isSuccess]);

	const handleFieldChange = (e) => {
		const { name, value } = e.target;
		// Validate numeric input
		if (/^(\d+)?$/.test(value)) {
			handleChange(e); // Call the parent change handler
			setFieldEdited((prev) => ({ ...prev, [name]: true })); // Mark the field as edited
		}
	};

	const renderIcon = (fieldName, value, maxLimit = 720) => {
		console.log({ fieldName, value });
		if (!fieldEdited[fieldName]) {
			return <div className="h-6"></div>;
		}

		if (value === "" || value == null || isNaN(Number(value))) {
			return (
				<i
					className="pi pi-exclamation-triangle text-orange-400"
					style={{ fontSize: "1.5rem" }}
					// title="Value is missing or invalid"
				></i>
			);
		}

		return value > maxLimit ? (
			<i
				className="pi pi-exclamation-circle text-red-400"
				style={{ fontSize: "1.5rem" }}
				// title="Value exceeds the maximum limit"
			></i>
		) : (
			<i
				className="pi pi-check-circle text-green-400"
				style={{ fontSize: "1.5rem" }}
				// title="Value is within the maximum limit"
			></i>
		);
	};

	console.log({ fieldEdited, isSuccess });
	return (
		<div>
			<div className="bg-primary-primaryYellow text-center p-2 font-bold">
				Storage Time Limits
			</div>

			<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
				<div className="flex h-auto gap-3 justify-center items-center">
					<div className="w-2/3">
						<p className="text-lg font-semibold">
							Storage Takeback Alert Limit:
						</p>
						<p className="text-sm">
							Maximum time for a recipient to pick up package before a take back
							request is sent to sender.
						</p>
					</div>

					<div className="grid grid-cols-9 w-1/3 items-center">
						<div className="col-span-1 flex justify-start items-center">
							<div className="col-span-1 flex justify-start items-center">
								{renderIcon("storageTakebackLimit", data.storageTakebackLimit)}
							</div>
						</div>

						<Textfield
							disabled={disabled}
							classNameParent={"col-span-7"}
							placeholder={"XXX"}
							value={data.storageTakebackLimit}
							name="storageTakebackLimit"
							className={`${
								fieldEdited.storageTakebackLimit &&
								data.storageTakebackLimit > 720
									? "border border-red-400 w-full my-auto"
									: ""
							}`}
							min={1}
							maxLength={3}
							onChange={(e) => {
								var numberPattern = /^(\d+)?$/;
								if (numberPattern.test(e.target.value)) {
									handleChange(e);
								}
								handleFieldChange(e);
							}}
						/>
						<p className="col-span-1 grid items-center justify-center">hrs</p>
					</div>
				</div>

				<div className="grid grid-cols-12 w-full">
					<div className="col-span-8"></div>

					<div className="col-span-4">
						<div className="justify-center grid w-full items-center">
							{fieldEdited.storageTakebackLimit &&
								(!data.storageTakebackLimit ||
								data.storageTakebackLimit === "" ? (
									<span className="col-span-7 text-orange-400">
										The field is required.
									</span>
								) : (
									data.storageTakebackLimit > 720 && (
										<span className="col-span-7 text-red-400">
											Invalid value! Maximum hour is 720.
										</span>
									)
								))}
						</div>
					</div>
				</div>
			</div>

			<div className="flex flex-col border-secondary-buttonHeaderGray border-x-2 border-b-2 p-2">
				<div className="flex h-auto gap-3 justify-center items-center">
					<div className="w-2/3">
						<p className="text-lg font-semibold">
							Storage Pullout Alert Limit:
						</p>
						<p className="text-sm">
							Maximum time a sender has to take back package before a pullout
							alert is sent. Computed from end of storage duration.
						</p>
					</div>

					<div className="grid grid-cols-9 w-1/3 items-center">
						<div className="col-span-1 flex justify-start items-center">
							<div className="col-span-1 flex justify-start items-center">
								{renderIcon("storagePulloutLimit", data.storagePulloutLimit)}
							</div>
						</div>

						<Textfield
							disabled={disabled}
							classNameParent={"col-span-7"}
							placeholder={"XXX"}
							value={data.storagePulloutLimit}
							name="storagePulloutLimit"
							min={1}
							maxLength={3}
							className={`${
								fieldEdited.storagePulloutLimit &&
								data.storagePulloutLimit > 720
									? "border border-red-400 w-full my-auto"
									: ""
							}`}
							onChange={(e) => {
								var numberPattern = /^(\d+)?$/;
								if (numberPattern.test(e.target.value)) {
									handleChange(e);
								}
								handleFieldChange(e);
							}}
						/>
						<p className="col-span-1 grid items-center justify-center">hrs</p>
					</div>
				</div>

				<div className="grid grid-cols-12 w-full">
					<div className="col-span-8"></div>

					<div className="col-span-4">
						<div className="justify-center grid w-full items-center">
							{fieldEdited.storagePulloutLimit &&
								(!data.storagePulloutLimit ||
								data.storagePulloutLimit === "" ? (
									<span className="col-span-7 text-orange-400">
										The field is required.
									</span>
								) : (
									data.storagePulloutLimit > 720 && (
										<span className="col-span-7 text-red-400">
											Invalid value! Maximum hour is 720.
										</span>
									)
								))}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
